import { useLocalization } from "@fluent/react";
import { Control, Controller } from "react-hook-form";
import styles from "./NewUsedSelect.module.css";
import { AutoDetailsFormInput } from "../../hooks/queries/AutoLoanApplication/types";

interface NewUsedSelectProps {
  control: Control<AutoDetailsFormInput>;
}

function NewUsedSelect({ control }: NewUsedSelectProps) {
  const { l10n } = useLocalization();

  return (
    <Controller
      name="condition"
      control={control}
      render={({ field: { onChange, value } }) => (
        <div className={styles.chipSelectContainer}>
          <button
            type="button"
            className={`${styles.chipSelect} ${value === "new" ? styles.chipSelectSelected : ""}`}
            onClick={() => onChange("new")}
          >
            {l10n.getString("auto-loan-auto-details-new-car", null, "New car")}
          </button>
          <button
            type="button"
            className={`${styles.chipSelect} ${value === "used" ? styles.chipSelectSelected : ""}`}
            onClick={() => onChange("used")}
          >
            {l10n.getString("auto-loan-auto-details-used-car", null, "Used car")}
          </button>
        </div>
      )}
    />
  );
}

export { NewUsedSelect };
